<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <loading v-if="! showContent"></loading>
                <h2 class="titulo" v-if="showContent">{{ title }}</h2>
                <div class="calendario eventContent">
                    <ul v-if="showContent">
                        <li v-for="item in items">
                            <router-link :to="getUrl()">
                                Até {{ item.dateFinish }}
                                <strong class="subtitle"> {{ item.name }}  </strong>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import { get } from '../../helpers/api';
    import Loading from '../common/Loading.vue';
    import { slugify } from '../../helpers/slugify';

    export default {
        components: {
            Loading
        },
        props: ['bloco'],
        data() {
            return {
                title: 'Promoções',
                showContent: true,
                items: [],
            }
        },
        created() {
            if (this.bloco.nome) {
                this.title = this.bloco.nome;
            }
            let self = this;
            // get('content/'+this.bloco.id).then(function (response) {
            //     self.showContent = true;
                // self.items = response.data.result.data;
                self.items = this.$store.getters['getSiteContent'].result.data.promocao;
                // self.items = window.siteconfig.result.data.promocao;
            // });
        },
        methods: {
            getUrl() {
                return '/promocoes/';
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/home/Promotions.vue